import React from "react"
import { Link } from "gatsby"

import Layout from "../components/Layout"

const IndexPage = () => (
  <Layout>
    <h1>
      Bem vindo <span>&#128062;</span>
    </h1>
    <h2>O que queremos fazer</h2>
    <p>Nosso objetivo é ajudar os amantes e cuidadores de animas. Se você:</p>
    <p>
      <ul>
        <li>Encontrou um cão ou gato perdido ou abandonado;</li>
        <li>Perdeu seu pet e precisa de ajuda para encontrá-lo;</li>
        <li>Deseja resgatar um animal para cuidados e adoção;</li>
        <li>Deseja adotar um;</li>
        <li>Possui animais para adoção e precisa administrar a operação;</li>
      </ul>
    </p>
    <p>
      O <strong>achem-me</strong> é o serviço com aplicativo que vai ajudar em
      tudo isso. E é de graça.
    </p>
    <p>
      A idéia é usar um smartphone para registrar animais avistados pelas ruas,
      salvando sua localização e características.
    </p>
    <p>
      Ao tirar uma foto, ele automaticamente registra se é um cachorro ou gato
      e, se possível, até a raça. Em seguida, complemente com as demais
      características e ele ficará gravado num banco de dados de acesso publico.
      Esse banco de dados poderá ser consultado de forma livre por quaisquer
      caracteríticas e por local (cidade).
    </p>
    <h3>Outros serviços</h3>
    <p>
      Você pode também incluir animais perdidos e animais colocados para adoção.
      E mais:
    </p>
    <p>
      <ul>
        <li>Registre eventos e anuncios na sua cidade;</li>
        <li>Registre-se como protetor e doador de animais;</li>
      </ul>
    </p>
  </Layout>
)

export default IndexPage
